/* eslint-disable */
import React, { useState,useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { 
  ArrowLeft,
  Calendar,
  CheckCircle2,
  Clock,
  Phone,
  Mail
} from "lucide-react";
import Cookies from "js-cookie";

const EnterpriseContact = () => {
  const navigate = useNavigate();
  const [showCalendar, setShowCalendar] = useState(false);

  useEffect(() => {
    localStorage.clear();
    const allCookies = Cookies.get();
    for (const cookieName in allCookies) {
      Cookies.remove(cookieName);
    }
  }, []);

  const handleBack = () => {
    navigate('/pricing-plans');
  };

  const handleBookAppointment = () => {
    window.open('https://calendly.com/salescaptain/demo_meet', '_blank');
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white p-4 sm:p-6 text-sm md:text-base">
      <div className="flex justify-center mb-10">
        <img
          src="https://s3.us-east-2.amazonaws.com/sc-prod-embedded.salescaptain.com/resources/2025-03-18/full_logo.a46683a620fa53c3c554_1742299090688.png"
          alt="SalesCaptain Logo"
          className="h-10 object-contain"
        />
      </div>

      <div className="w-full max-w-2xl mx-auto">
        <div className="bg-white rounded-lg shadow-lg p-6 sm:p-8">
          <div className="text-center mb-8">
            <CheckCircle2 className="h-8 md:h-16 w-8 md:w-16 text-green-500 mx-auto mb-4" />
            <p className="text-lg md:text-2xl font-semibold mb-2">
              Enterprise Plan Request Submitted!
            </p>
            <p className="text-gray-600">
              Thank you for your interest in our Enterprise plan.
            </p>
          </div>

          <div className="bg-blue-50 border border-blue-100 rounded-lg p-6 mb-8">
            <div className="flex items-start gap-3">
              <Clock className="h-6 w-6 text-blue-600 mt-1 flex-shrink-0" />
              <div>
                <h3 className="font-medium text-blue-900 mb-2">
                  What happens next?
                </h3>
                <p className="text-blue-800 text-sm md:text-base">
                  Our sales team will contact you within the next <strong>48 hours</strong> to discuss your custom Enterprise requirements and provide you with a tailored solution.
                </p>
              </div>
            </div>
          </div>

          <div className="space-y-4 mb-8">
            <h3 className="text-lg font-medium text-center">
              Want to schedule a call at your convenience?
            </h3>
            <p className="text-gray-600 text-center">
              Book a meeting with our Enterprise solutions expert to discuss your needs in detail.
            </p>
          </div>

          <div className="space-y-4">
            <button
              onClick={handleBookAppointment}
              className="w-full h-12 bg-blue-600 hover:bg-blue-700 text-white rounded-lg flex items-center justify-center gap-2 font-medium"
            >
              <Calendar size={20} />
              Book Appointment
            </button>

            {/* <div className="text-center text-sm text-gray-500">
              Or contact us directly:
            </div>

            <div className="flex flex-col sm:flex-row gap-3">
              <div className="flex-1 flex items-center justify-center gap-2 p-3 border border-gray-200 rounded-lg">
                <Phone size={16} className="text-blue-600" />
                <span className="text-sm">+1(218) 261-7787</span>
              </div>
              <div className="flex-1 flex items-center justify-center gap-2 p-3 border border-gray-200 rounded-lg">
                <Mail size={16} className="text-blue-600" />
                <span className="text-sm">ravi@salescaptain.com</span>
              </div>
            </div> */}
          </div>

          {/* <div className="mt-8 flex justify-center">
            <button
              onClick={handleBack}
              className="flex items-center gap-2 text-blue-600 hover:text-blue-700 text-sm"
            >
              <ArrowLeft size={16} />
              Back to Pricing Plans
            </button>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default EnterpriseContact;